window.updateDrawerCoverage = function () {
  const drawer = document.querySelector('cart-drawer, #CartDrawer');
  if (!drawer) return;

  const coverageOutput = drawer.querySelector('[data-js-coverage]');
  const packMultiplierEl = drawer.querySelector('[data-pack-multiplier]');
  const qtyInput = drawer.querySelector('.quantity__input');

  if (!coverageOutput || !packMultiplierEl || !qtyInput) return;

  const baseCoverage = parseInt(coverageOutput.dataset.baseCoverage, 10) || 3600;
  const packMultiplier = parseInt(packMultiplierEl.dataset.packMultiplier, 10) || 1;
  const qty = parseInt(qtyInput.value, 10) || 1;

  const total = baseCoverage * packMultiplier * qty;

  coverageOutput.textContent = total.toLocaleString('en-US');

  console.log('drawer coverage updated', {
    packMultiplier,
    qty,
    total,
    packMultiplierEl,
    qtyInput,
    coverageOutput
  });
};